import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { checkboxGroupDriverFactory } from './CheckboxGroup.driver';
import { CheckboxGroup } from '.';
import { Checkbox } from '../Checkbox';

const noop = () => {};
const TestComp: React.FunctionComponent<any> = (props) => (
  <CheckboxGroup {...props}>
    <Checkbox name="group1" onChange={noop} label="Checkbox 1️⃣" />
    <Checkbox name="group1" onChange={noop} label="Checkbox 2️⃣" />
    <Checkbox name="group1" onChange={noop} label="Checkbox 3️⃣" />
  </CheckboxGroup>
);

describe('CheckboxGroup', () => {
  const createDriver = createRendererWithUniDriver(checkboxGroupDriverFactory);

  it('should render with childrens', async () => {
    const { driver } = createDriver(<TestComp />);

    expect(await driver.exists()).toBe(true);
    expect(await driver.isCheckboxesExist()).toBe(true);
  });

  it('should disable all checkboxes with disabled prop', async () => {
    const { driver } = createDriver(<TestComp disabled />);

    expect(await driver.isCheckboxesDisabled()).toBe(true);
  });

  it('should show error state at all checkboxes with error prop', async () => {
    const { driver } = createDriver(<TestComp error />);

    expect(await driver.isCheckboxesErrored()).toBe(true);
  });

  it('should set lang to root', async () => {
    const lang = 'he';
    const { driver } = createDriver(<TestComp lang={lang} />);

    expect(await driver.getLang()).toBe(lang);
  });
});
